import { useCallback, useEffect, useState } from "react";

import { getOrder } from "services/orders/rest";
import { OrderDto } from "services/orders/restModels";

export interface UseOrderResult {
    order: OrderDto | null;
    loading: boolean;
    error: boolean;
    // Мутация, отдающая заказ целиком (возврат платежа), кладёт ответ сюда вместо второго запроса.
    setOrder: (order: OrderDto) => void;
    refetch: () => void;
}

export const useOrder = (orderId: number | null): UseOrderResult => {
    const [order, setOrder] = useState<OrderDto | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<boolean>(false);
    const [reloadKey, setReloadKey] = useState<number>(0);

    const refetch = useCallback(() => setReloadKey((key) => key + 1), []);

    useEffect(() => {
        if (orderId === null) {
            setOrder(null);
            setError(true);
            setLoading(false);
            return undefined;
        }

        let ignore = false;

        setLoading(true);
        setError(false);

        getOrder(orderId)
            .then((result) => {
                if (ignore) return;
                if (result) {
                    setOrder(result);
                } else {
                    setError(true);
                    setOrder(null);
                }
            })
            .catch(() => {
                if (ignore) return;
                setError(true);
                setOrder(null);
            })
            .finally(() => {
                if (ignore) return;
                setLoading(false);
            });

        return () => {
            ignore = true;
        };
    }, [orderId, reloadKey]);

    return { order, loading, error, setOrder, refetch };
};
